import React from 'react';
import { useAuth } from '../../auth';

const PendingAccessPage: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center space-y-4">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto">
          <span className="text-3xl">⏳</span>
        </div>
        <h1 className="text-xl font-bold text-gray-900">Acesso Pendente</h1>
        <p className="text-sm text-gray-600">
          Olá <span className="font-medium">{user?.name}</span>, sua conta foi criada com sucesso!
        </p>
        <p className="text-sm text-gray-500">
          Um administrador precisa aprovar seu acesso antes que você possa utilizar o sistema.
          Você será redirecionado automaticamente quando aprovado.
        </p>
        <div className="pt-4 border-t">
          <button onClick={logout} className="text-sm text-gray-500 hover:text-gray-700 underline">
            Sair e usar outra conta
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingAccessPage;
